import api from './api';
import { Customer, CustomerSearchParams } from '../types';

const getAll = () => {
  return api.get('/customers');
};

const getById = (id: number) => {
  return api.get(`/customers/${id}`);
};

const findByPhone = (phone: string) => {
  return api.get('/customers/search', { params: { phoneNumber: phone } });
};

const search = (params: { phoneNumber?: string, name?: string }) => {
  return api.get('/customers/search', { params });
};

const create = (data: Customer) => {
  const customerData = {
    ...data,
    phoneNumber: data.phoneNumber || ''
  };
  return api.post('/customers', customerData);
};

const update = (id: number, data: Customer) => {
  return api.put(`/customers/${id}`, data);
};

const remove = (id: number) => {
  return api.delete(`/customers/${id}`);
};

const CustomerService = {
  getAll,
  getById,
  findByPhone,
  search,
  create,
  update,
  remove
};

export default CustomerService; 